import { CoreService } from "./../../services/coreService";
import {
  Component,
  OnInit,
  ChangeDetectorRef,
  Output,
  EventEmitter,
  Inject,
  Optional
} from "@angular/core";
import {
  UntypedFormGroup,
  UntypedFormBuilder,
  ReactiveFormsModule,
  Validators
} from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
declare let toastr: any;

@Component({
    selector: "beneficiary-delete-modal",
    templateUrl: "./beneficiary-delete-modal.component.html",
    styleUrls: ["./beneficiary-delete-modal.component.scss"],
    standalone: true,
    imports: [ReactiveFormsModule]
})
export class BeneficiaryDeleteModalComponent implements OnInit {
  form: UntypedFormGroup;
  attemptedSubmit = false;
  beneficiaries;
  @Output() close = new EventEmitter();
  @Output() submit = new EventEmitter<{ password: string; id: string }>();

  constructor(
    private builder: UntypedFormBuilder,
    private coreService: CoreService,
    private detectChanges: ChangeDetectorRef,
    public dialogRef: MatDialogRef<BeneficiaryDeleteModalComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.form = this.builder.group({
      id: [null, [Validators.required]]
    });
  }

  closeModal() {
    this.resetModal();
    this.close.emit();
    this.dialogRef.close(null);
  }

  resetModal() {
    this.form.reset();
    this.attemptedSubmit = false;
  }

  submitForm() {
    this.attemptedSubmit = true;
    if (this.form.valid) {
      this.submit.emit(this.form.value);
      this.dialogRef.close(this.form.value);
      this.resetModal();
    }
  }

  async ngOnInit() {
    try {
      this.beneficiaries = await this.coreService
        .GetBeneficiaries()
        .then(response => response.data);
      this.detectChanges.detectChanges();
    } catch (error) {
      toastr.error("", "Failed to fetch beneficiaries.", {
        timeOut: 2000
      });
      this.closeModal();
    }
  }
}
